<div class="image-annotation">
  <div class="image-annotation__container">
    <div class="image-annotation__inner-container">
      <div
        class="image-annotation__content"
        id="annotate-view"
      >
        @if (curAnn) {
          <div
            class="image-annotation__inner-content"
            id="annotate-parent-container"
          >
            @if (curAnn.annotateImage && curAnn.annotateImage.image_id) {
              <app-annotation-canvas
                class="image-annotation__canvas-container"
                [curAnn]="curAnn"
                [parentContainerId]="'annotate-parent-container'"
                [edit]="edit"
                [isDialog]="false"
                [dashboardId]="'annotate-dashboard'"
              ></app-annotation-canvas>
            }

            <form
              class="image-annotation__dashboard-container"
              name="annotateDashboardForm"
            >
              @if (curAnn.parentObject) {
                <app-annotation-dashboard
                  class="image-annotation__dashboard"
                  [curAnn]="curAnn"
                  [mediaList]="false"
                  id="annotate-dashboard"
                ></app-annotation-dashboard>
              }
            </form>
          </div>
        }
      </div>
    </div>
  </div>
</div>
